import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSearchParams } from 'react-router-dom';
import { Card, InputAdornment, Stack, Typography, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../reusable-components/iconify';
import { MinimalLogo } from '../../reusable-components/logo';
import FormProvider, { RHFTextField } from '../../reusable-components/hook-form';
import { FORGOT_PASSWORD_SCHEMA } from '../../reusable-components/form/authSchema';
import { useSnackbar } from '../../reusable-components/snackbar';
import { forgotPassword } from '../../api/account';

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const { enqueueSnackbar } = useSnackbar();
  const [submitting, setSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const methods = useForm({ resolver: yupResolver(FORGOT_PASSWORD_SCHEMA), defaultValues: { email: searchParams.get('email')?.trim() } });

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    setSubmitting(true);
    forgotPassword(data.email)
      .then(res => {
        if (res) {
          enqueueSnackbar('Reset password email sent', { variant: 'success' });
          setIsSuccess(true);
        }
        else enqueueSnackbar(`Failed to reset password`, { variant: 'error' });
      })
      .catch(() => enqueueSnackbar(`Failed to reset password`, { variant: 'error' }))
      .finally(() => setSubmitting(false));
  };

  return (
    <Card sx={{ m: 3, p: 3 }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: -13 }}>
            <MinimalLogo disabledLink />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="h3" color="primary">
              Reset Password
            </Typography>
          </Box>
          {isSuccess && <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="body2">
              Success! Please check your email and follow the link to complete the process.
            </Typography>
          </Box>}
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
              Email
            </Typography>
            <RHFTextField
              name="email"
              fullWidth
              placeholder="Enter your email "
              InputProps={{
                startAdornment: (<InputAdornment position="start">
                  <Iconify icon="eva:email-outline" />
                </InputAdornment>),
              }}
            />
          </Box>

          <LoadingButton fullWidth color="primary" size="large" type="submit" variant="contained" loading={submitting}>
            Reset Password
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Card>
  );
}
